import { useAppDispatch, useAppSelector } from '@/store/hooks'
import { useEffect } from 'react'
import { modalCreators } from '@/store/ducks/modal'
import modalsService from '@/services/modalsService'
import modalsMentorshipsService from '@/services/modalsMentorshipsService '

export const useShowModals = () => {
	const dispatch = useAppDispatch()

	const {
		auth: { user },
	} = useAppSelector((state) => state)

	const { data: feedbacksModal, isLoading, isSuccess } = modalsService.list()

	useEffect(() => {
		if (isSuccess && !isLoading && feedbacksModal) {
			if (feedbacksModal?.liveClasses[0]) {
				dispatch(
					modalCreators.openModal({
						name: 'feedbackClassModal',
						disabledOnClose: true,
						modalInfo: feedbacksModal?.liveClasses[0],
					})
				)
				return
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [feedbacksModal, isSuccess])

	useEffect(() => {
		if (user?.show_modal_skill_mapping && user?.link_skill_mapping)
			dispatch(
				modalCreators.openModal({
					name: 'skillMappingModal',
					disabledOnClose: true,
					modalInfo: {
						link_skill_mapping: user.link_skill_mapping,
					},
				})
			)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user?.show_modal_skill_mapping, user?.link_skill_mapping])
}

export const useShowModalsMentorships = () => {
	const dispatch = useAppDispatch()

	const {
		data: feedbacksModal,
		isLoading,
		isSuccess,
	} = modalsMentorshipsService.list()

	useEffect(() => {
		if (isSuccess && !isLoading && feedbacksModal) {
			if (feedbacksModal?.studentMentorships[0]) {
				dispatch(
					modalCreators.openModal({
						name: 'studentMentorshipFeedbackModal',
						modalInfo: feedbacksModal?.studentMentorships[0],
					})
				)
				return
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [feedbacksModal, isSuccess])
}
